import { Component, Input, Output, EventEmitter, OnInit } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import {
  NG_VALUE_ACCESSOR,
  ControlValueAccessor,
  FormsModule,
} from "@angular/forms";
import { environment } from "environments/environment";
import { ScrollerOptions } from "primeng/api";
import { CommonModule } from "@angular/common";
import { Dropdown, DropdownModule } from "primeng/dropdown";
import * as _ from "lodash";
import { InputTextModule } from "primeng/inputtext";

@Component({
  imports: [CommonModule, FormsModule, DropdownModule, InputTextModule],
  standalone: true,
  selector: "nis-google-font-picker",
  templateUrl: "./google-font-picker.component.html",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: GoogleFontPickerComponent,
      multi: true,
    },
  ],
})
export class GoogleFontPickerComponent implements ControlValueAccessor, OnInit {
  @Input()
  brandFonts: any[] = [];
  @Input()
  styleClass: string = "";

  @Input()
  label: string = "";
  fonts: any[] = [];
  _selectedFont: string = "";
  loading: boolean = false;

  options: ScrollerOptions = {
    delay: 250,
    showLoader: true,
    lazy: true,
    onLazyLoad: this.onLazyLoad.bind(this),
  };

  private API_KEY = environment.google_font_api_key;

  onChange = (font: string) => {};
  onTouched = () => {};

  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    this.loadFonts();
  }

  loadFonts() {
    this.loading = true;
    this.http
      .get(
        `https://www.googleapis.com/webfonts/v1/webfonts?key=${this.API_KEY}`
      )
      .subscribe((response: any) => {
        const fonts = response.items;
        for (let brandFont of this.brandFonts) {
          const cleanedFontName = brandFont.data.value
            .replace(/"/g, "")
            .replace(/'/g, "");
          const font = _.find(fonts, {
            family: cleanedFontName,
          });
          if (font) {
            font.brand_name = brandFont.data.name;
          }
          //move the font at the beginning of the list
          _.remove(fonts, { family: font.family });
          fonts.unshift(font);
        }
        this.fonts = fonts;
        this.loading = false;
      });
  }

  loadGoogleFonts(fonts: string[]) {
    const link = document.createElement("link");
    link.href = `https://fonts.googleapis.com/css?family=${fonts.join("|")}`;
    link.rel = "stylesheet";
    document.head.appendChild(link);
  }

  writeValue(font: string): void {
    if (font) {
      this._selectedFont = font.replace(/"/g, "").replace(/'/g, "");
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  set selectedFont(font: string) {
    this._selectedFont = font;
    const value = `'${font}'`;
    const brandFont = _.find(
      this.brandFonts,
      (brandFont) => brandFont.data.value === value
    );
    this.onChange(brandFont ? `var(--${brandFont.key})` : value);
  }

  get selectedFont(): string {
    return this._selectedFont;
  }

  onLazyLoad(event: any) {
    console.log("onLazyLoad", event);
    if (event.first < this.fonts.length) {
      const newFonts = this.fonts.slice(event.first, event.last);
      this.loadGoogleFonts(newFonts.map((font) => font.family));
    }
  }

  onFilter(dropdown: Dropdown) {
    if (dropdown.scroller) {
      dropdown.scroller.contentEl.style.transform =
        "translate3d(0px, 0px, 0px)";
    }
  }
}
